import { useState } from "react";
import AmountToWords from "../../../../_utils/AmountToWords";
import Validation from "../../../../../utils/validation";
import Loader from "../../../../Loader/Index";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import globalText from "../../../../../utils/globalText";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import { PaymentMethodAnimationConfiguration } from "../../../../../utils/configurationProvider";

const TaxTransactionStepAmount = ({
  txnPayLoad,
  setTxnPayLoad,
  isNeft,
  setIsNeft,
  isRtgs,
  setIsRtgs,
  copyData,
  setCopyData,
  txnLoading,
}) => {
  const [slideAnimation, setSlideAnimation] = useState(false);
  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };
  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const amountInWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedAmountWords =
        amountNumber > 0 && amountNumber <= 1
          ? amountInWords.replace("rupees", "rupee")
          : amountInWords;

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedAmountWords,
      }));
    }
  };

  return (
    <>
      {txnLoading ? (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-fixed-ui bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className=" font-semibold text-font-lg text-text-primary">
                Validating the data
              </p>
            </div>
          </div>
        </>
      ) : (
        <div
          className={`w-width-full flex flex-col Qlg:flex-row Qlg:px-padding-base px-padding-md gap-gap-md Qsmd:gap-gap-xl Qsmd:pt-padding-md pt-padding-md max-w-tab-width-normal mx-auto`}
        >
          <div
            className="w-width-full max-h-auto rounded-border-radius-md"
            style={{ scrollbarWidth: "none" }}
          >
            <Amount
              title={globalText.TRANSFER_AMOUNT}
              amount={txnPayLoad?.amount}
              amountInWords={txnPayLoad?.amountInWords}
              copyData={copyData}
              onAmountChange={(val) =>
                handleAmountChange({ name: "amount", value: val })
              }
              onPasteApplied={() => {
                if (copyData?.title === "Transfer Amount") {
                  const pastedValue = copyData?.value?.toString();
                  handleAmountChange({
                    name: "amount",
                    value: pastedValue,
                  });
                }
                setCopyData({ title: "", data_type: "", value: "" });
              }}
              isPreview={false}
            />
          </div>
          <div className={`w-width-full`}>
            <PaymentMethodSelector
              title={globalText.SELECT_PAYMENT_METHOD}
              slideAnimation={slideAnimation}
              previewMode={false}
              methods={[
                {
                  key: "neft",
                  label: globalText.NEFT,
                  subText: globalText.NEFT_TRANSFER_NOTE,
                  active: isNeft,
                  notes: [
                    globalText.TRANSACTION_EXECUTION_NOTE,
                    globalText.TRANSACTION_LIMIT_NOTE,
                    globalText.TRANSACTION_CHARGES_NOTE,
                  ],
                  onClick: () => {
                    if (!isNeft) setSlideAnimation(true);
                    setTimeout(
                      () => setSlideAnimation(false),
                      PaymentMethodAnimationConfiguration.slideDuration,
                    );
                    setIsNeft(true);
                    setIsRtgs(false);
                    setTxnPayLoad({ ...txnPayLoad, settleType: "neft" });
                  },
                },
                {
                  key: "rtgs",
                  label: globalText.RTGS,
                  subText: globalText.INSTANT_TRANSFER_NOTE,
                  active: isRtgs,
                  notes: [
                    globalText.RTGS_TRANSACTION_EXECUTION_NOTE,
                    globalText.RTGS_TRANSACTION_LIMIT_NOTE,
                    globalText.TRANSACTION_CHARGES_NOTE,
                  ],
                  onClick: () => {
                    if (!isRtgs) setSlideAnimation(true);
                    setTimeout(
                      () => setSlideAnimation(false),
                      PaymentMethodAnimationConfiguration.slideDuration,
                    );
                    setIsNeft(false);
                    setIsRtgs(true);
                    setTxnPayLoad({ ...txnPayLoad, settleType: "rtgs" });
                  },
                },
              ]}
            />
          </div>

          <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
        </div>
      )}
    </>
  );
};

export default TaxTransactionStepAmount;
